module.exports = __webpack_public_path__ + "img/no_photos.62f7bd5a.svg";